import { createStore } from "vuex";
import analytics from "./modules/analytics";
import auth from "./modules/auth";
import businessVerticals from "./modules/businessVerticals";
import contractDistributions from "./modules/contractDistributions";
import insurerManagers from "./modules/insurerManagers";
import merchantProfiles from "./modules/merchantProfiles";
import notifications from "./modules/notifications";
import organizations from "./modules/organizations";
import planSales from "./modules/planSales";
import stores from "./modules/stores";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  key: "vuex_insurer",
  storage: window.localStorage,
});

export default createStore({
  modules: {
    analytics,
    auth,
    businessVerticals,
    contractDistributions,
    insurerManagers,
    merchantProfiles,
    notifications,
    organizations,
    planSales,
    stores,
  },
  plugins: [vuexLocal.plugin],
});
